import { Link } from 'react-router-dom';
import { Unlink as UnlinkIcon, Unplug } from 'lucide-react';

// A row for one doc type on a file's or folder's detail page: the name and
// section as a link to the type page, plus an action button — Unlink if the
// row is already attached, Link if it's a candidate. The two visual variants
export default function DocTypeLinkRow({ definitionId, name, sectionName, kind, onAction }: {
    definitionId: string;
    name: string;
    sectionName?: string | null;
    kind: 'linked' | 'candidate';
    onAction: () => void;
}) {
    const linked = kind === 'linked';
    return (
        <div className={`flex items-center gap-3 px-3.5 py-3 rounded-lg ${linked
            ? 'border border-sage/30 bg-sage/5'
            : 'bg-white border border-softgrey'}`}>
            <Link to={`/types/${definitionId}`} className="flex-1 min-w-0 hover:opacity-70 transition-opacity">
                <span className="text-sm font-medium text-graphite truncate block">{name}</span>
                {sectionName && (
                    <span className="text-[12px] text-coolslate truncate block mt-0.5">{sectionName}</span>
                )}
            </Link>
            <button
                onClick={onAction}
                className={`flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-medium border rounded-md transition-colors cursor-pointer shrink-0 ${linked
                    ? 'text-red-600 bg-red-50 hover:bg-red-100 border-red-200'
                    : 'text-insight bg-insight/8 hover:bg-insight/15 border-insight/20'}`}
            >
                {linked ? <UnlinkIcon className="w-3 h-3" /> : <Unplug className="w-3 h-3" />}
                {linked ? 'Unlink' : 'Link'}
            </button>
        </div>
    );
}
